import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';
import { setLoading } from 'store/reducers/mainSlice';
import Logo from 'assets/images/logo-light.svg';
import { Alert } from '@mui/material';
import './NewLogin.scss'; // Import your CSS file


const defaultTheme = createTheme({
	palette: {
		main: {
			primary: '#192138'
		}
	}
});

// ✅ Clear
export default function ForgotPasswordOTP() {
	const navigate = useNavigate();
	const matches = useMediaQuery('(max-width:900px)');
	const { state } = useLocation();
	const { email, token } = state || {};
	const isMobile = useMediaQuery('(max-width:900px)');
	useEffect(() => {
		document.title = 'Projectmix - Login';
		if (!state || !email || !token) {
			navigate('/login');
		}
	}, []);

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm();
	const [emsg, setEmsg] = useState('');
	const dispatch = useDispatch();
	const [timeLeft, setTimeLeft] = useState(180);


	const onSubmit = (event) => {
		event.preventDefault();
		const formData = new FormData(event.currentTarget);

		const data = {
			token: token,
			otp: `${formData?.get('otp-0')}${formData?.get('otp-1')}${formData?.get('otp-2')}${formData?.get('otp-3')}`
		};

		dispatch(setLoading(true));

		api.forgotPasswordOtp(data).then((res) => {
			const token = res.data[0];
			if (res.status) {
				navigate('/new-password', { state: { token } });
			} else {
				setEmsg(res.message);
				setTimeout(() => setEmsg(''), 3000);
			}
			dispatch(setLoading(false));
		});
	};

	const resubmitOtp = (event) => {
		event.preventDefault();
		setTimeLeft(180);
		const data = {
			email: email
		};

		dispatch(setLoading(true));

		api.forgotPassword(data).then((res) => {
			const {
				data: { email, token }
			} = res;
			if (res.status) {
				navigate('/forgot-password-otp', { state: { email, token } });
			} else {
				setEmsg(res.message);
				setTimeout(() => setEmsg(''), 3000);
			}
			dispatch(setLoading(false));
		});
	};

	useEffect(() => {
		document.title = 'Projectmix - Login';

		if (!timeLeft) return;

		const intervalId = setInterval(() => {
			setTimeLeft(timeLeft - 1);
		}, 1000);

		return () => clearInterval(intervalId);
	}, [timeLeft]);


	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid container component="main" sx={{ height: '100dvh' }}>
				<Grid
					item
					xs={false}
					sm={false}
					md={6}
					// hidden={{ xs: true, sm: false, md: false }}
					sx={{
						// backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
						backgroundRepeat: 'no-repeat',
						// backgroundColor: (t) => (t.palette.mode === 'light' ? t.palette.grey[900] : t.palette.grey[900]),
						background: 'radial-gradient(circle at left,#36214A,#161618 40%)',
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexDirection: 'column',
						borderRight: '2px solid #373843'
					}}
					className="hidden-sm-grid-item"
				>
					<img src={Logo} style={{ width: '40%' }}></img>
				</Grid>

				<Grid
					item
					xs={12}
					sm={12}
					md={6}
					component={Paper}
					square
					sx={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'space-between',
						backgroundColor: '#181823',
						flex: '1' // make the Grid fill the remaining space
					}}
					container
					spacing={isMobile ? 0 : 2}
				>
					{matches && <img src={Logo} style={{ width: '290px', marginTop: '20%' }} alt="Projectmix.ai" />}
					
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
							width: '100%',
							flex: '1', // make the Box take up all available space
							marginTop: isMobile ? '0' : '20%'
						}}
					>
						<Typography component="h1" variant="h5" className="login-text-gray ">
							{timeLeft > 0 ? (
								<h5 style={{ paddingTop: '10px' }}>
									Time left: {Math.floor(timeLeft / 60)}:{timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60}
								</h5>
							) : (
								<h5 style={{ paddingTop: '10px' }}>OTP expired!</h5>
							)}
						</Typography>
						<Box component="form" noValidate onSubmit={onSubmit} sx={{ mt: 1 }}>
							{emsg && (
								<Alert
									severity="error"
									sx={{
										marginBottom: '5px'
									}}
								>
									{emsg}
								</Alert>
							)}
							<div style={{ display: 'flex', justifyContent: 'space-between', maxWidth: 300 }}>
								{[0, 1, 2, 3].map((_, index) => (
									<TextField
										key={index}
										margin="normal"
										required
										fullWidth
										id={`otp-${index}`}
										name={`otp-${index}`}
										autoComplete="off"
										autoFocus={index === 0} // autofocus only on the first input
										type="text"
										className="login-form-field form-control-md font12 otp-input"
										style={{
											WebkitTextFillColor: '#fff !important',
											marginRight: index < 3 ? '10px' : '0'
										}}
										inputProps={{
											maxLength: 1,
											style: {
												// apply styles directly to the input field
												textAlign: 'center', // center the text
												fontWeight: 'bold'
											}
										}}
										onChange={(e) => {
											if (e.target.value.length === 1) {
												document.getElementById(`otp-${index + 1}`)?.focus();
											}
										}}
										onPaste={(e) => {
											e.preventDefault();
											const pastedData = e.clipboardData.getData('text');
											pastedData.split('').forEach((char, i) => {
												const input = document.getElementById(`otp-${i}`);
												if (input) input.value = char;
											});
										}}
									/>
								))}
							</div>
							<Button type="submit" className="signin-button" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
								Submit OTP
							</Button>
							{timeLeft === 0 && (
								<Typography className="login-text-gray" style={{ textAlign: 'center', fontSize: '12px' }}>
									<Link
										to="#"
										variant="body2"
										onClick={(event) => {
											event.preventDefault();
											resubmitOtp(event);
										}}
									>
										Resend OTP
									</Link>
								</Typography>
							)}

						</Box>
					</Box>
					<Typography className="login-text-gray" style={{ textAlign: 'center', fontSize: '12px', width: '100%', marginBottom: '15%' }}>
						Copyright ©{' '}
						<Link href="#" variant="body2">
							Projectmix
						</Link>{' '}
						2024.
					</Typography>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}
